// extracted by mini-css-extract-plugin
module.exports = {"pageCardBtn":"cardHeaderButton_pageCardBtn__2FB-p"};